var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"DialogBox"},[(_vm.props.title ? true : false)?_c('p',{staticClass:"topMsg"},[_vm._v(_vm._s(_vm.props.title))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }